import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import FieldCard from "../../../components/WriteProject/FieldCard/FieldCard";
import InsertBtn from "../../../components/WriteProject/InsertBtn/InsertBtn";
import WpTitle from "../../../components/WriteProject/WpTitle/WpTitle";
import { ProjectType } from "../../../interface/interface";
function Step3() {
  const {
    state: {
      field: { detail },
    },
    UpdateCommon,
  }: {
    state: ProjectType;
    UpdateCommon: (
      type: string,
      payload: string | number,
      index: number | undefined
    ) => void;
  } = useOutletContext();
  const [isOpen, setIsOpen] = useState<number | undefined>(undefined);
  return (
    <div className="step3">
      <WpTitle title="모집 분야 및 인원" />
      <div className="card-wrapper">
        {detail.map((item, idx) => {
          return (
            <FieldCard
              key={`${idx}`}
              index={idx}
              data={item}
              __update={UpdateCommon}
              __setopen={setIsOpen}
              isOpen={isOpen}
            />
          );
        })}
      </div>
      <InsertBtn
        title="모집분야 입력란 추가"
        __init={UpdateCommon}
        type="detail/add"
      />
    </div>
  );
}

export default Step3;
